import classNames from 'classnames'
import { useRouter } from 'next/router'
import { FC, useState } from 'react'

type Props = {
  isPageWithSecdeAyah: boolean
}

const HayratKuranPage: FC<Props> = ({ isPageWithSecdeAyah }) => {
  const router = useRouter()
  const page = router.query.page as string
  const [isFullScreen, setIsFullScreen] = useState(false)

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen)
  }

  return (
    <>
      <div
        className={classNames('bg-dark rounded-2x mb-2 bg-amber-100', {
          'absolute top-0 left-0 right-0 z-30 m-0 mt-0 min-h-screen w-auto p-4 pt-4 text-center':
            isFullScreen,
          'flex-center': !isFullScreen,
        })}
      >
        {isFullScreen && (
          <p className="font-medium tracking-wide">
            {page}{' '}
            {isPageWithSecdeAyah ? (
              <>
                {' | '}
                <span className="bg-green-200 px-1 roounded">Secde Ayeti Var</span>
              </>
            ) : (
              ''
            )}
          </p>
        )}
        <img
          onClick={toggleFullScreen}
          className={classNames('dark:invert', {
            'm-auto': isFullScreen,
          })}
          src={`https://onlinedua.org/images/kuran/${page}.png`}
          alt={page}
        />
      </div>
    </>
  )
}

export default HayratKuranPage
